import * as React from "react"

export const Page = ({ children }: { children: React.ReactNode }) => {
  return (
    <span className="Page">
      <Entry>
        <Key label="page" />
        <Delimiter />
        <Value type="object">{children}</Value>
      </Entry>
    </span>
  )
}

export const Post = ({ children }: { children: React.ReactNode }) => (
  <span className="Post">
    <Entry trailing={true}>
      <Key label="post" />
      <Delimiter />
      <Value type="object">{children}</Value>
    </Entry>
  </span>
)

export const Navigation = ({ children }: { children: React.ReactNode }) => (
  <span className="Navigation">
    <Entry trailing={true}>
      <Key label="navigation" />
      <Delimiter />
      <Value type="array">{children}</Value>
    </Entry>
  </span>
)

export const List = ({ values }: { values: React.ReactNode }) => {
  const wrappedChildren = React.Children.map(values, c => (
    <ListItem>
      <Value trailing={true} listItem={true}>
        {c}
      </Value>
    </ListItem>
  ))
  return (
    <span className="List">
      <Value type="array">{wrappedChildren}</Value>
    </span>
  )
}

export const ListItem = ({ children }: { children: React.ReactNode }) => (
  <div className="ListItem">{children}</div>
)

export const Text = ({ children }: { children: React.ReactNode }) => (
  <span className="Text">"{children}"</span>
)

export const Key = ({ label }: { label: string }) => (
  <span className="Key">"{label}"</span>
)

export const Delimiter = () => <span className="Delimiter">: </span>

export const Value = ({
  children,
  type = "string",
  trailing = false,
  listItem = false,
}: {
  children: React.ReactNode
  type?: ValueType
  trailing?: boolean
  listItem?: boolean
}) => {
  const className = `Value Value--${type}`
  const suffix = trailing ? "," : ""
  const content = (
    <span className={`Value__content Value__content--${type}`}>{children}</span>
  )

  switch (listItem) {
    case false:
      return (
        <span className={className}>
          <OpenNode type={type} />
          {content}
          <CloseNode type={type} />
          {suffix}
        </span>
      )
    case true:
      return (
        <span className={className}>
          <OpenNode type={type} />
          {content}
          <CloseNode type={type} />
          {suffix}
        </span>
      )
  }
}

const OpenNode = ({ type }: { type: ValueType }) => {
  switch (type) {
    case "array":
      return <span className="OpenNode OpenNode--array">{"["}</span>
    case "object":
      return <span className="OpenNode OpenNode--object">{"{"}</span>
    case "string":
    default:
      return null
  }
}

const CloseNode = ({ type }: { type: ValueType }) => {
  switch (type) {
    case "array":
      return <span className="CloseNode CloseNode--array">{"]"}</span>
    case "object":
      return <span className="CloseNode CloseNode--object">{"}"}</span>
    case "string":
    default:
      return null
  }
}

type ValueType = "string" | "object" | "array"

export const HtmlText = ({ value }: { value: string }) => (
  <span className="HtmlText">
    "<span dangerouslySetInnerHTML={{ __html: value }} />"
  </span>
)

export const Entry = ({
  children,
  trailing = false,
}: {
  children: React.ReactNode
  trailing?: boolean
}) => (
  <div className="Entry">
    {children}
    {trailing && ","}
  </div>
)
